import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderDetailsByOid } from 'projects/zbs-app/src/app/services/Ebootis.Queries/OrderDetailsByOid';
import { PrintService } from '../../../print/print.service';
import { OrderService } from '../../order.service';

@Component({
  selector: 'app-order-print',
  templateUrl: './order-print.component.html',
  styleUrls: ['./order-print.component.scss']
})
export class OrderPrintComponent implements OnInit {

  public m_queryData: OrderDetailsByOid.Result;

  m_selectedOrder: string;

  constructor(route: ActivatedRoute,
    private m_orderService: OrderService,
    private printService: PrintService) {
    this.m_selectedOrder = route.snapshot.params['selectedOrder'];
  }


  ngOnInit() {
    this.m_orderService.getOrderDetailsByOid({ order: this.m_selectedOrder }).subscribe({
      next: (res) => {
        this.m_queryData = res;
        document.title = res.id;
        this.printService.onDataReady();
      },
      error: (error) => {
        console.error("Order mit UID" + this.m_selectedOrder + " nicht gefunden");
        console.log(error);
      }
    });
  }

  /**
   * setzt eine anzuzeigende Bezeichnung
   * für die LogisticsArea zusammen
   * (falls vorhanden).
   * @param p_element 
   */
  public getLogisticsAreaString(p_element): string {
    let str = '';
    if (p_element.logisticArea) {
      str = p_element.logisticArea.name;

      if (p_element.logisticArea.descr) {
        str += "- " + p_element.logisticArea.descr;
      }
    }
    return str;
  }

}